import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function Profile() {
  const { user } = useAuth();
  const [profile, setProfile] = useState({ user: null, dealer: null });
  const [pwd, setPwd] = useState({ current_password: "", new_password: "" });
  useEffect(() => { api.get("/dealer/profile").then(({ data }) => setProfile(data)); }, []);
  const changePassword = async () => {
    try { await api.post("/auth/change-password", pwd); toast.success("Password updated"); setPwd({ current_password: "", new_password: "" }); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const d = profile.dealer || {};
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="dealer-profile">
      <div><h1 className="font-display text-2xl sm:text-3xl font-black">Profile</h1><p className="text-muted-foreground">Company information, contact, password and notification preferences.</p></div>
      <Card>
        <CardHeader><CardTitle>Account</CardTitle></CardHeader>
        <CardContent className="space-y-2 text-sm">
          <div className="flex justify-between"><span className="text-muted-foreground">Contact person</span><span className="font-semibold">{user?.full_name}</span></div>
          <div className="flex justify-between"><span className="text-muted-foreground">Email</span><span>{user?.email}</span></div>
          <div className="flex justify-between"><span className="text-muted-foreground">Role</span><Badge>{user?.role}</Badge></div>
        </CardContent>
      </Card>
      {d.id && (
        <Card>
          <CardHeader><CardTitle>Business profile · {d.name}</CardTitle></CardHeader>
          <CardContent className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-muted-foreground">Dealer code</span><span className="font-mono">{d.code}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Region</span><span>{d.region}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Phone</span><span>{d.phone}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Email</span><span>{d.email}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Pricing tier</span><Badge variant="outline">{d.pricing_tier || "STANDARD"}</Badge></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Credit limit</span><span>₹{(d.credit_limit || 0).toLocaleString()}</span></div>
          </CardContent>
        </Card>
      )}
      <Card>
        <CardHeader><CardTitle>Change password</CardTitle></CardHeader>
        <CardContent className="space-y-3 max-w-md">
          <div><Label>Current password</Label><Input type="password" value={pwd.current_password} onChange={(e) => setPwd({ ...pwd, current_password: e.target.value })} data-testid="dpwd-current" /></div>
          <div><Label>New password</Label><Input type="password" value={pwd.new_password} onChange={(e) => setPwd({ ...pwd, new_password: e.target.value })} data-testid="dpwd-new" /></div>
          <Button onClick={changePassword} disabled={!pwd.current_password || !pwd.new_password} data-testid="dpwd-save">Update password</Button>
        </CardContent>
      </Card>
    </div>
  );
}
